var module = angular.module("meternet.report.directives", [
    "meternet.report.energy.directives"
]);
